import React, { useMemo } from "react";
import style from "./index.module.scss";
import VideoLocalPlayer from "./components/VideoLocalPlayer";
import HtmlView from "./components/HtmlView";
import { Empty } from "antd";
import { CourseWareTypeList } from "utils/common";
import VideoViewer from "../../../CourseComponents/CourseWareViewer/components/VideoViewer";
import DocViewer from "../../../CourseComponents/CourseWareViewer/components/DocViewer";

interface CourseWareViewerProps<T> {
    data: T & { fileType?: string; viewUrl?: string };
}

export default function CourseWareViewer<T>({
    data
}: CourseWareViewerProps<T>) {
    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    data?.fileType?.toLowerCase() || ""
                )
            ) {
                return type;
            }
        }
        return "";
    }, [data]);

    return (
        <div className={style.root}>
            {fileType === "video" && data?.viewUrl?.includes("http") && (
                <VideoLocalPlayer src={data?.viewUrl || ""} />
            )}
            {fileType === "video" && !data?.viewUrl?.includes("http") && (
                <VideoViewer key={data?.viewUrl} vid={data?.viewUrl || ""} />
            )}

            {["ppt", "word", "excel", "pdf", "pic"].includes(fileType) && (
                <DocViewer src={data?.viewUrl || ""} />
            )}

            {["href", "polyv"].includes(fileType) && (
                <HtmlView src={data?.viewUrl || ""} />
            )}
            {![
                "ppt",
                "word",
                "excel",
                "pdf",
                "pic",
                "href",
                "video",
                "polyv"
            ].includes(fileType) && (
                <div className={style.center}>
                    <Empty description="当前文件格式不支持预览，请下载到本地查看" />
                </div>
            )}
        </div>
    );
}
